import {Autocomplete, Box, Button, Grid, Paper, Tab, Tabs, TextField, Typography} from "@mui/material";
import {Fragment, useContext, useEffect, useState} from "react";
import {CheckTireComponent} from "./checks/TireComponent";

// ALERT
import Swal from "sweetalert2";
import {promiseServer, requestServer} from "../Global/FunctionToConnection";
import {AuthContext} from "../Global/AuthContext";
import {triggerAlert} from "../Global/SwanAlertComponent";
import {ReportFailedDialogComponent} from "./checks/ReportFailedComponent";
import {LevelsCheckComponent, VALUES_LEVELS} from "./checks/LevelsComponent";
import {Loading} from "../Global/LoadingComponent";
import {DEBUG, URL_SERVER, URL_TEST} from "../Global/constant";
import dayjs from "dayjs";


const TABS_HEADER =[
    { label: "Llantas" , component: (title, report , setReport, bus) => <CheckTireComponent titleTab={title} report={report} setReport={setReport} isBus={bus}/>},
    { label: "Niveles" , component: (title, report , setReport, bus) => <LevelsCheckComponent titleTab={title} report={report} setReport={setReport} isBus={bus}/>},
]

const REPORT_INIT = {
    status: false,
    text: null
}

const REPORT_VALUE = {
    P1: "",
    m1:"",
    presion_1: 0,
    P2: "",
    m2:"",
    presion_2: 0,
    P3: "",
    m3:"",
    presion_3: 0,
    P4: "",
    m4:"",
    presion_4: 0,
    P5: "",
    m5:"",
    presion_5: 0,
    P6: "",
    m6:"",
    presion_6: 0,
    aceite:"",
    direccion:"",
    refrigerante:"",
    clutch:"",
};

function allyProps(index) {
      return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
      };
}

function CustomTabPanel(props) {
      const { children, value, index, ...other } = props;

      return (
            <div
                  role="tabpanel"
                  hidden={value !== index}
                  id={`simple-tabpanel-${index}`}
                  aria-labelledby={`simple-tab-${index}`}
                  {...other}
            >
                  {value === index && (
                        <Box sx={{ p: 3 }}>
                          <Typography>{children}</Typography>
                        </Box>
                  )}
            </div>
      );
}

export function MainComponent(){

    const { isMobile } = useContext(AuthContext);

    const [tabSelected, setTabSelected] = useState(0);

    const [unitSelected, setUnitSelected] = useState(null);

    const [report, setReport] = useState(REPORT_VALUE);

    const [reportFailed, setReportFailed] = useState(REPORT_INIT);

    const [unitOptions, setUnitOptions] = useState([]);

    const [unitCheck, setUnitCheck] = useState([]);

    useEffect(() => {
        const getUnits = async () => {
            try{

                let responseUnit = await promiseServer("pre-orden-reporte");
                let url = DEBUG? URL_TEST.unidad_supervisor: URL_SERVER.unidad_supervisor;
                let responseUnitCheck = await requestServer(url,null, DEBUG);
                // console.log("responseUnitCheck →", responseUnitCheck.datos)
                let datosResquest = responseUnitCheck.datos;
                let success = [];
                let error = [];
                for (let index = 0; index < datosResquest.length; index++) {
                    if(datosResquest[index].status){
                        // console.log("datosResquest →", dayjs(datosResquest[index].date.substring(0,10)).format("DD-MM-YYYY"))
                        let new_date = `${dayjs(datosResquest[index].date.substring(0,10)).format("DD-MM-YYYY")} ${datosResquest[index].date.substring(10,datosResquest[index].date.length)}`;
                        success.push({...datosResquest[index], date: new_date});
                    }else{
                        error.push(datosResquest[index]);
                    }
                }
                setUnitCheck([...success, ...error]);

                if(!unitSelected && responseUnit.respuesta === 'exito'){
                    setUnitOptions(()=> responseUnit.unidad);

                    await triggerAlert({
                        titleAlert: 'Cargando unidades',
                        bodyAlert: `Seleccione una unidad para hacer su revisión.`,
                    });
                }

            }catch (e) {
                console.error(e);
                await triggerAlert({
                    titleAlert:'Error',
                    bodyAlert:`Ocurrió un problema con la conexión, revisa el internet o comunícate con el departamento de sistemas.`,
                    typeAlert: "error"
                })
            }
        }

        getUnits();
    }, [unitSelected]);

    const handlingSelectedUnit = async (event, unitData) => {

        await triggerAlert({
            titleAlert: 'Unidad seleccionada',
            bodyAlert: `Has seleccionado la unidad ${unitData.label}. No podrás cambiar de unidad en el proceso de revisión, a menos que canceles o guardes la información`,
            typeAlert: "warning"
        })
        setReport(oldData=>{
            return{
                ...oldData,
                unit: unitData
            }
        })
        setUnitSelected(unitData);
    }

    const handlingCancelCheck = () =>{
        setUnitSelected(null);
        setReport(REPORT_VALUE);
    }

    const handlingChangeTab = (event, valueTab) =>{
        setTabSelected(valueTab);
    }

    const handlingCreatedCheck = async () => {

        let check = checkValuesBeforeCreatedTire();
        if(check.length > 0){
            let bodyText = "Los campos :<br/>";

            for (let index = 0; index < check.length; index++) {
                bodyText = `${bodyText} ${check[index]} <br/>`;
            }
            bodyText = `${bodyText} No pueden ir vacios `;

            await triggerAlert({
                titleAlert: "Campos vacíos",
                bodyAlert: bodyText,
                typeAlert: 'error',
            })

            return;
        }

        let titleCreated = `Se va a guardar la revisión de la unidad ${unitSelected.label}`;
        let textCreated = getTextValues();

        if(!!reportFailed.text){
            textCreated = `${textCreated} <br/>`;
            textCreated = `${textCreated} Con reporte de la siguiente falla:</br>`;
            textCreated = `${textCreated} ${reportFailed.text} <br/>`;
        }else{
            textCreated = `${textCreated} Sin ningún reporte`
        }

        Swal.fire({
            title: titleCreated,
            html: textCreated,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar',
        }).then(async (result) => {
            Loading({open:true});
            if (result.isConfirmed) {

                let params = {
                    sucursal: parseInt(unitSelected.sucursal),
                    unidad: unitSelected,
                    marca: null,
                    modelo: null,
                    tipo_llanta: null,
                    P1: `${unitSelected.nombre}-${report.P1.label}`,
                    M1: report.m1,
                    presion_1: parseFloat(report.presion_1),
                    P2: `${unitSelected.nombre}-${report.P2.label}`,
                    M2: report.m2,
                    presion_2: parseFloat(report.presion_2),
                    P3: `${unitSelected.nombre}-${report.P3.label}`,
                    M3: report.m3,
                    presion_3: parseFloat(report.presion_3),
                    P4: unitSelected.label[0].toUpperCase() === 'C'? `${unitSelected.nombre}-${report.P3.label}` : `N/A`,
                    M4: report.m4,
                    presion_4: parseFloat(report.presion_4),
                    P5: `N/A`,
                    M5: unitSelected.label[0].toUpperCase() !== 'C'? report.m5 : 0,
                    presion_5: parseFloat(report.presion_5),
                    P6: unitSelected.label[0].toUpperCase() !== 'C'? `${unitSelected.nombre}-${report.P6.label}` : `N/A`,
                    M6: unitSelected.label[0].toUpperCase() !== 'C'? report.m6 : 0,
                    presion_6: parseFloat(report.presion_6),
                    aceite: report.aceite,
                    refrigerante: report.refrigerante,
                    direccion: report.direccion,
                    clutch: 0,
                    reporte: reportFailed.text,
                }
                let url = DEBUG? URL_TEST.unidad_revision : URL_SERVER.unidad_revision;

                try{
                    let responseService = await requestServer(url, params, DEBUG);
                    console.log("responseService →", responseService)
                    if(responseService.respuesta === "exito"){
                        // setUnitSelected(null);
                        // setReport(REPORT_VALUE);
                        // setReportFailed(REPORT_INIT);

                        await triggerAlert({
                            titleAlert: "¡Revision creada con exito!",
                            bodyAlert: "Correcto"
                        })
                        Loading({open:false});
                    }else{
                        await triggerAlert({
                            titleAlert: "¡Error!",
                            bodyAlert: "Si el error persiste, ponte en contacto con el equipo de sistemas"
                        })
                        Loading({open:false});
                    }

                }catch (e) {
                    console.error(e)
                }



            }
            Loading({open:false});
        });
    }

    const handlingCheckClose = () =>{
        if(reportFailed.text === ''){
            setReportFailed(REPORT_INIT);
        }
        else if(!!reportFailed.text){
            setReportFailed(old=>{return{...old, status:false }});
        }else{
            setReportFailed(REPORT_INIT);
        }
    }

    function checkValuesBeforeCreatedTire(){

        let idsErrors = [];
        let keyValuesTire = unitSelected.label[0].toUpperCase() !== 'C'?
            ["P1", "m1" , "presion_1" ,"P2", "m2" , "presion_2","P3", "m3" ,"presion_3","m4", "presion_4"]
            :["P1", "m1" , "presion_1" ,"P2", "m2" , "presion_2","P3", "m3","presion_3","P4" ,"m4", "presion_4"];
        if(unitSelected.label[0].toUpperCase() !== 'C'){
            keyValuesTire = [ ...keyValuesTire, "m5" ,"presion_5" ,"P6", "m6", "presion_6"];
        }
        keyValuesTire = [ ...keyValuesTire, "aceite", "direccion", "refrigerante"]
        for (let index = 0; index < keyValuesTire.length; index++) {

            if(report[keyValuesTire[index]] === ""){
                idsErrors.push(keyValuesTire[index]);

            }

        }
        return idsErrors;
    }

    function getTextValues(){
        let bodyText = `Con los valores en las llantas: <br/>`;

        let keyValuesTire = unitSelected.label[0].toUpperCase() !== 'C'?
            ["P1", "m1" , "presion_1" ,"P2", "m2" , "presion_2","P3", "m3" ,"presion_3","m4", "presion_4"]
            :["P1", "m1" , "presion_1" ,"P2", "m2" , "presion_2","P3", "m3","presion_3","P4" ,"m4", "presion_4"];
        if(unitSelected.label[0].toUpperCase() !== 'C'){
            keyValuesTire = [ ...keyValuesTire, "m5" ,"presion_5" ,"P6", "m6", "presion_6"]
        }
        for (let index = 0; index < keyValuesTire.length; index++) {
            // bodyText = `${bodyText} ${keyValuesTire[index]} = ${report[keyValuesTire[index]]} `;
            if(keyValuesTire[index][0] === 'm' || keyValuesTire[index][0] === 'p'){
                bodyText = `${bodyText} ${keyValuesTire[index]} = ${report[keyValuesTire[index]]} <br/>`;
            }else{
                bodyText = `${bodyText} ${keyValuesTire[index]} = ${report[keyValuesTire[index]].label} | `;
            }
        }
        bodyText = `${bodyText} <br/> Con valores en los niveles de: <br/>`;
        let levels = ["aceite", "direccion", "refrigerante"];

        for (let index = 0; index < levels.length; index++) {
            let text = VALUES_LEVELS.find(item => item.id === report[levels[index]] );
            bodyText = `${bodyText} ${levels[index]} = ${text? text.label: "Sin reporte"} <br/>`;
        }
        return bodyText;
    }


    return(
        <Grid container>

            <Grid item xs={12} style={{backgroundColor: "rgba(33, 150, 243,0.4)", marginTop: "2vh"}}
                  container
                  direction="row"
                  justifyContent="center">
                <Tabs variant="scrollable" scrollButtons="auto" value={tabSelected} onChange={handlingChangeTab}
                    aria-label="scrollable auto tabs example">
                    {
                        TABS_HEADER.map((things, index)=>(
                            <Tab style={{height: "5vh"}} key={`tab-head-${index}`} label={<p>{things.label}</p>} {...allyProps(index)}/>
                        ))
                    }
                </Tabs>
            </Grid>

            {
                unitSelected &&
                <Grid item xs={12} container mt={2}
                      direction="row"
                      justifyContent="flex-end">
                    {
                        !!reportFailed.text?
                        <Button variant="contained" color="info" onClick={()=>setReportFailed({...reportFailed, status: true})} >Editar Reporte</Button>:
                        <Button variant="contained" color="warning" onClick={()=>setReportFailed({...reportFailed, status: true})} >Reportar falla</Button>
                    }
                </Grid>
            }

            <Grid container item xs={12} direction="row" mt={2}>

                <Grid item xs={isMobile ? 12 : (!unitSelected ? 12:8)}>
                    <Autocomplete
                        options={unitOptions}
                        value={unitSelected}
                        readOnly={!!unitSelected }
                        onChange={handlingSelectedUnit}
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        renderInput={
                            (params) => <TextField {...params} label="Unidad" />}
                        />
                </Grid>

                {
                    unitSelected &&
                    <Fragment>

                        <Grid item xs={isMobile ? 6 : 2}>
                            <Button fullWidth variant="contained" color="error" onClick={handlingCancelCheck}>
                                Cancelar
                            </Button>
                        </Grid>

                        <Grid item xs={isMobile ? 6 : 2}>
                            <Button fullWidth variant="contained" color="success" onClick={handlingCreatedCheck}>
                                Guardar
                            </Button>
                        </Grid>

                    </Fragment>
                }

            </Grid>


            {
                !!unitSelected &&
                TABS_HEADER.map((things, index)=>(
                    <Grid item xs={12} key={`tab-content-${index}`}
                          container
                          direction="row"
                          justifyContent="center"
                          alignItems="center">
                            <CustomTabPanel  index={index} value={tabSelected}>
                                {things.component(things?.label, report , setReport, unitSelected?.label[0].toUpperCase() !== 'C')}
                            </CustomTabPanel>
                    </Grid>
                ))
            }


            {
                reportFailed.status &&
                <ReportFailedDialogComponent
                    open={reportFailed.status}
                    failedReport={reportFailed}
                    setFailedReport={setReportFailed}
                    handlingClose={handlingCheckClose}
                />
            }

            <Grid item xs={12} m={2}>
                <Typography>
                    Tus unidades son:
                </Typography>
            </Grid>

            <Grid item container xs={12} spacing={1} direction="row" justifyContent="center" alignItems="center" >
                {
                    unitCheck.map((things, index) =>(
                        <Grid item xs={2} key={`unidad-${things.nombre}-${index}`}  >

                            <Paper style={{backgroundColor: things.status? "rgba(34, 197, 94, 0.6)":"rgba(244, 63, 94, 0.8)"}} p={1}>
                                <Typography style={{ textAlign: 'center' }} >{things.nombre}</Typography>
                                <Typography style={{ textAlign: 'center' }} >Ultima fecha revisada: {things.date}</Typography>
                            </Paper>

                        </Grid>
                    ))
                }
            </Grid>



        </Grid>
    );
}